module.exports = __webpack_public_path__ + "assets/sovren-logo.e16635f7.svg";